import React, { useEffect, useState } from 'react'
import ShipperCopy from '../components/DigitalLR/ShipperCopy'
import { useParams } from 'react-router-dom'
import { supabase } from '../supabase.config'
import LMCopy from '../components/DigitalLR/LMCopy'
import AccountsCopy from '../components/DigitalLR/AccountsCopy'
import RecieverCopy from '../components/DigitalLR/RecieverCopy'
import { Button } from '@material-tailwind/react'
import { FaFilePdf } from 'react-icons/fa'
import toast, { Toaster } from 'react-hot-toast'

const DigitalLR = () => {
  const { id } = useParams()
  const [orderDetail, setOrderDetail] = useState({})
  const parseJSON = (v) => { if (!v) return null; if (typeof v === 'object') return v; try { return JSON.parse(v) } catch { return null } }
  const computeChargeable = (dims) => {
    try {
      return Math.ceil((dims||[]).reduce((sum, d) => sum + (((Number(d.length)||0)*(Number(d.width)||0)*(Number(d.height)||0))/4500)*(Number(d.count)||0), 0))
    } catch { return 0 }
  }
  const fetchOrderDetail = async () => {
    let row = null
    let { data, error } = await supabase.from('orders').select('*').eq('id', id).single()
    if (error) {
      const byTrack = await supabase.from('orders').select('*').eq('tracking_number', id).single()
      if (!byTrack.error && byTrack.data) {
        row = byTrack.data
      } else {
        const byOrderId = await supabase.from('orders').select('*').eq('order_id', id).single()
        if (!byOrderId.error && byOrderId.data) {
          row = byOrderId.data
        } else {
          const byOrder = await supabase.from('orders').select('*').eq('order_number', id).single()
          if (!byOrder.error && byOrder.data) row = byOrder.data
        }
      }
    } else row = data
    if (!row) return
    const pickup = parseJSON(row.pickup_address) || {}
    const drop = parseJSON(row.delivery_address) || {}
    const dims = parseJSON(row.dimensions) || []
    const pkg = parseJSON(row.package_details) || {}
    const mapped = {
      createdAt: row.created_at,
      pickup_location: pickup,
      dropoff_location: drop,
      invoices: pkg.invoices || [],
      dimensions: dims,
      weight: row.weight,
      totalChargeableWeight: computeChargeable(dims),
      orderID: row.order_id || row.order_number || '',
      lrno: row.tracking_number || row.order_number || '',
      userName: pkg.userName || pickup?.pickupName?.companyName || pickup?.companyName || pickup?.personName || ''
    }
    setOrderDetail(mapped)
  }
  useEffect(() => {
    fetchOrderDetail()
  }, [id])

  const downloadAllWaybills = () => {
    try {
      // Find all waybill containers by their class - more specific selector
      const waybillElements = document.querySelectorAll('div[class*="border-gray-600"]')
      const waybillContents = []

      // Collect all waybill HTML content
      waybillElements.forEach((element) => {
        // Check if this is a waybill container (has min-w-[1000px] or max-w-[1200px])
        const classes = element.className || ''
        if (classes.includes('min-w-[1000px]') || classes.includes('max-w-[1200px]')) {
          const clonedContent = element.cloneNode(true)
          
          // Fix image sources to be absolute URLs
          const images = clonedContent.querySelectorAll('img')
          images.forEach(img => {
            const src = img.getAttribute('src') || img.src
            if (src && !src.startsWith('http') && !src.startsWith('data:')) {
              // Convert relative paths to absolute
              const absoluteUrl = new URL(src, window.location.origin).href
              img.setAttribute('src', absoluteUrl)
            }
          })
          
          // Ensure barcodes and SVGs are visible
          const svgs = clonedContent.querySelectorAll('svg')
          svgs.forEach(svg => {
            svg.style.display = 'block'
            svg.style.maxWidth = '100%'
            svg.style.height = 'auto'
            svg.setAttribute('style', 'display: block; max-width: 100%; height: auto;')
          })
          
          // Ensure all borders are visible
          const borderedElements = clonedContent.querySelectorAll('[class*="border"]')
          borderedElements.forEach(el => {
            const style = el.getAttribute('style') || ''
            if (!style.includes('border')) {
              el.setAttribute('style', style + ' border-color: #000 !important;')
            }
          })
          
          waybillContents.push(clonedContent.outerHTML)
        }
      })

      if (waybillContents.length === 0) {
        toast.error('No waybills found to download')
        return
      }

      // Create a single print window with all waybills
      const printWindow = window.open('', '_blank', 'width=1200,height=800')
      
      if (!printWindow) {
        toast.error('Please allow popups to download waybills')
        return
      }

      // Get all stylesheets
      const linkTags = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
        .map(link => `<link rel="stylesheet" href="${link.href}">`)
        .join('\n')
      
      // Get inline styles from the page
      const styleTags = Array.from(document.querySelectorAll('style'))
        .map(style => `<style>${style.innerHTML}</style>`)
        .join('\n')

      // Combine all waybills with proper page breaks and containers
      const combinedContent = waybillContents
        .map((content, index) => {
          // Wrap each waybill in a page container
          return `<div class="waybill-page">
            <div class="waybill-container">
              ${content}
            </div>
          </div>`
        })
        .join('')

      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>All Waybills - ${orderDetail?.lrno || id}</title>
            ${linkTags}
            ${styleTags}
            <style>
              * {
                box-sizing: border-box;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              
              @page {
                size: A4 landscape;
                margin: 0.5cm;
              }
              
              @media print {
                body {
                  margin: 0;
                  padding: 0;
                  background: white;
                  -webkit-print-color-adjust: exact;
                  print-color-adjust: exact;
                }
                
                .waybill-page {
                  width: 100%;
                  max-width: 100%;
                  margin: 0;
                  padding: 0;
                  page-break-after: always;
                  page-break-inside: avoid;
                  overflow: hidden;
                }
                
                .waybill-page:last-child {
                  page-break-after: auto;
                }
                
                .waybill-container {
                  width: 100%;
                  min-width: 1000px;
                  max-width: 1200px;
                  margin: 0 auto;
                  border: 2px solid #000 !important;
                  background: white !important;
                  box-shadow: none;
                }
                
                .waybill-container * {
                  -webkit-print-color-adjust: exact;
                  print-color-adjust: exact;
                  color-adjust: exact;
                }
                
                img {
                  max-width: 100%;
                  height: auto;
                  display: block;
                }
                
                svg {
                  max-width: 100%;
                  height: auto;
                  display: block;
                }
                
                table, tr, td {
                  page-break-inside: avoid;
                }
                
                .grid {
                  display: grid;
                }
                
                /* Ensure borders are visible */
                [class*="border"] {
                  border-color: #000 !important;
                }
              }
              
              @media screen {
                body {
                  margin: 0;
                  padding: 20px;
                  background: #f5f5f5;
                }
                
                .waybill-page {
                  margin-bottom: 20px;
                }
                
                .waybill-container {
                  width: 100%;
                  min-width: 1000px;
                  max-width: 1200px;
                  margin: 0 auto;
                  border: 1px solid #000;
                  background: white;
                }
              }
              
              body {
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
                margin: 0;
                padding: 0;
              }
            </style>
          </head>
          <body>
            ${combinedContent}
          </body>
        </html>
      `)

      printWindow.document.close()

      // Wait for content to load, then trigger print
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.print()
          toast.success('All waybills ready for download!')
        }, 1000)
      }
      
      // Fallback if onload doesn't fire
      setTimeout(() => {
        if (printWindow.document.readyState === 'complete') {
          printWindow.print()
          toast.success('All waybills ready for download!')
        }
      }, 2000)

    } catch (error) {
      console.error('Error downloading waybills:', error)
      toast.error('Failed to download waybills: ' + (error.message || 'Unknown error'))
    }
  }

  return (
    <div className='flex mt-6 items-center justify-center flex-col'>
      <Toaster />
      <div className='mb-6 flex gap-4'>
        <Button
          onClick={downloadAllWaybills}
          className='bg-[#FFB200] hover:bg-[#e6a000] text-black font-[GilroyMedium] flex items-center gap-2 px-6 py-3 rounded-lg shadow-lg'
        >
          <FaFilePdf className='w-5 h-5' />
          Download All Waybills
        </Button>
      </div>
      <ShipperCopy orderDetail={orderDetail} id={id} />
      <LMCopy orderDetail={orderDetail} id={id} />
      <RecieverCopy orderDetail={orderDetail} id={id} />
      <AccountsCopy orderDetail={orderDetail} id={id} />
    </div>
  )
}

export default DigitalLR
